import Dialog from '@stimulus-components/dialog'

export default class extends Dialog {
  connect() {
    super.connect()
    console.log("[Dialog Controller] Connected.")
    
    // 监听全局关闭指令
    this.closeModal = () => this.close()
    window.addEventListener("modal:close", this.closeModal)
  }

  disconnect() {
    super.disconnect()
    window.removeEventListener("modal:close", this.closeModal)
  }

  // 统一入口：无论是点击链接还是 JS 触发，只要 Frame 内容更新了，就调用这里
  open(event) {
    console.log("[Dialog Controller] Frame rendered. Opening modal...")
    
    // 1. 调用父类方法显示 (如果支持)
    super.open()
    
    // 2. 强制兜底显示 (防止父类方法兼容性问题)
    this.dialogTarget.showModal ? this.dialogTarget.showModal() : this.dialogTarget.setAttribute("open", "")
    this.dialogTarget.classList.remove("hidden")
  }

  close() {
    super.close()
    this.clear()
  }

  stop(e) {
    e.stopPropagation()
  }

  clear() {
    const frame = this.element.querySelector("#modal_content")
    if (frame) {
      frame.innerHTML = ""
      frame.src = "" // 清空 src 防止下次打开时闪烁
      
      // 重置为 Loading 状态
      const loader = document.createElement("div")
      loader.className = "flex items-center justify-center py-12"
      loader.innerHTML = '<div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>'
      frame.appendChild(loader)
    }
  }
}
